import script from "./SelectSortOrderFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSortOrderFilter.vue?vue&type=script&setup=true&lang=js"

import "./SelectSortOrderFilter.vue?vue&type=style&index=0&id=74921c92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74921c92"]])

export default __exports__